<template>
  <b-card
    no-body
  >
    <b-card-header>
      <!--      <b-card-title>-->
      <!--        <label-->
      <!--            v-t="`modules.customers.s_c`"-->
      <!--            class="section-label"-->
      <!--        />-->
      <!--      </b-card-title>-->
      <i-input
        :errors="errors"
        type="select"
        title="modules.customers.s_c"
        class="w-100"
        :validation-rules="['required']"
        :options="options"
        :clearable="true"
        :value="selected.name"
        label="name"
        @input=" val => $emit('update:selected', val || {})"
      >
        <template #list-header>
          <li
            v-b-toggle.sidebar-add-new-customer
            class="add-new-customer-header d-flex align-items-center my-50"
          >
            <feather-icon
              icon="PlusIcon"
              size="16"
            />
            <span
              v-t="`modules.customers.pages.add`"
              class="align-middle ml-25"
            />
          </li>
        </template>
      </i-input>
      <!--      @input="v => $emit('update:model-value', v)"-->
      <!--                :reduce="val => val.value"-->
    </b-card-header>
<!--    <b-card-body class="card-profile with-border pt-2">-->

<!--      <div class="d-flex justify-content-center align-items-center mt-1">-->
<!--        <div class="mr-1">-->
<!--          <b-avatar-->
<!--            size="64"-->
<!--            :text="avatarText(selected.name)"-->
<!--          />-->
<!--        </div>-->
<!--        <div class="profile-user-info">-->
<!--          <h6 class="mb-0">-->
<!--            {{ selected.name }}-->
<!--          </h6>-->
<!--          <div>-->
<!--            <small class="text-muted">{{ selected.email }}</small>-->
<!--          </div>-->
<!--          <div>-->
<!--            <small class="text-muted ltr"><span class="d-block">{{ selected.formatted_mobile }}</span></small>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div-->
<!--          v-if="!selected.id"-->
<!--          class="profile-user-info"-->
<!--        >-->
<!--          <h6 class="mb-0">-->
<!--            <b-badge-->
<!--              pill-->
<!--              variant="light-secondary"-->
<!--              style="width: 120px; height: 21px"-->
<!--            >&nbsp;</b-badge>-->
<!--          </h6>-->
<!--          <small class="text-muted text-left">-->
<!--            <b-badge-->
<!--              pill-->
<!--              variant="light-secondary"-->
<!--              class="mt-50 mr-1"-->
<!--              style="width: 100px; height: 16px;"-->
<!--            >&nbsp;</b-badge>-->
<!--          </small>-->
<!--        </div>-->
<!--      </div>-->
<!--    </b-card-body>-->
    <sidebar-add-new-customer
      id="sidebar-add-new-customer"
      :is-sidebar-active.sync="isSidebarActive"
      @refetch-data="$emit('submit')"
    />
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader, VBToggle,
} from 'bootstrap-vue'
import { ref } from 'vue'
import { avatarText } from '@core/utils/filter'
import SidebarAddNewCustomer from '@/views/models/customers/add/SidebarAddNewCustomer.vue'

export default {
  components: {
    BCard,
    SidebarAddNewCustomer,
    // BSV
    BCardHeader,
  },
  directives: {
    'b-toggle': VBToggle,
  },
  props: {
    options: {
      type: Array,
      default: Array,
    },
    selected: {
      type: Object,
      default: Object,
    },
    errors: {
      type: Array,
      default: Array,
      required: false,
    },
  },
  methods: { avatarText },
  emits: ['update:selected', 'submit'],
  setup(props, { emit }) {
    const isSidebarActive = ref(false)

    return {
      isSidebarActive,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.add-new-customer-header {
  padding: $options-padding-y $options-padding-x;
  color: $success;

  &:hover {
    background-color: rgba($success, 0.12);
  }
}

[dir] .dark-layout .card .card-body.with-border {
  border-color: #3b4253;
}
[dir] .card .card-body.with-border {
  border-top: 1px solid #dae1e7;
  border-top-color: rgb(218, 225, 231);
}
</style>
